
import axios from 'axios';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import MenuPage from './MenuPage';
const { ace } = window;

const NoticePage = () => {

    const { token } = useSelector((state) => state.AuthReducer);

    useEffect(() => {
        handleInit();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);


    const handleInit = async () => {
        const url = `https://ihongss.com/api/member/file_notice.json`;
        const headers = { "Content-Type": "application/json", "auth": token };
        const { data } = await axios.get(url, { headers });
        // console.log(data);

        if (data.status === 200) {
            var editor1 = ace.edit("editor1", {
                theme: "ace/theme/eclipse",
                mode: "ace/mode/java",
                maxLines: Infinity,
                wrap: true,
                /* fontFamily : 'Nanum Gothic', */
                fontSize: "16px",
                autoScrollEditorIntoView: true,
                showPrintMargin: false,
                keyboardHandler: "ace/keyboard/vscode",
            });

            editor1.setValue(data.doc.filedata);
            editor1.gotoLine(0, 0);

            editor1.setReadOnly(true);
            editor1.setHighlightActiveLine(false);
            editor1.setHighlightGutterLine(false);
            editor1.renderer.$cursorLayer.element.style.display = "none";
        }
    };


    return (
        <div>
            <div className="card flex justify-content-center"
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1000,
                    background: '#f0f2f5',
                    paddingTop: '5px',
                    paddingBottom: '2px',
                }}
            >
                <div>
                    <MenuPage />
                </div>

                <hr />
            </div>

            <div className="container">
                <div className="row">
                    <div id="editor1"></div>
                </div>
            </div>

            <footer>
                <div className="container">
                    <div className="row">
                        <p className="copyright text-muted">2016 &copy; ihongss.com</p>
                    </div>
                </div>
            </footer>

        </div>
    );
};

export default NoticePage;
